export default __webpack_public_path__ + "static/media/admin_product_discount_active.54888b7f.svg";